<template>
    <div style="background-color:#fff;line-height: 0;">
        <div class="stock" v-if="purchased == 1">


            <!-- 新智能诊股内容 -->
            <div class="phone_znzg" aria-label="智能诊股行情逻辑" v-if="has_ai_report">
                
                <div class="overview overview_k">

                    <div class="overview_kh">
                        <div class="overview_kh1">
                            <span>{{ name }}</span>
                            <span v-if="stock_data" :class="[stock_data.chg_pct>0 ? 'red' : 'green']">{{ stock_data.price }}</span>

                        </div>
                        <div class="overview_kh2">
                            <span >{{ code }}</span>
                            <span v-if="stock_data" :class="[stock_data.chg_pct>0 ? 'red' : 'green']">{{ stock_data.chg }} {{ stock_data.chg_pct }}%</span>
                        </div>
                    </div>


                    <!-- 切换按钮 -->
                    <div class="chart-tabs">
                        <button
                            :class="['tab-btn', { active: chartType === 'time' }]"
                            @click="switchChart('time')"
                        >
                            分时
                        </button>
                        <button
                            :class="['tab-btn', { active: chartType === 'daily' }]"
                            @click="switchChart('daily')"
                        >
                            日K
                        </button>
                        <button
                            :class="['tab-btn', { active: chartType === 'weekly' }]"
                            @click="switchChart('weekly')"
                        >
                            周K
                        </button>
                        <button
                            :class="['tab-btn', { active: chartType === 'monthly' }]"
                            @click="switchChart('monthly')"
                        >
                            月K
                        </button>
                    </div>

                    <div class="chart-wrapper">
                        <img v-if="loading" class="loading-overlay" src="https://img.aigupiao.com/www/20151121/loading.gif" />


                        <div class="overview_chart" v-show="chartType != 'time'">
                            <!-- k线 -->
                            <div @click="openstock()" v-show="stockData">
                                <KLine :stockData="stockData" />
                            </div>

                        </div>

                        <div class="overview_chart"  v-show="chartType === 'time'">
                            <!-- 分时 -->
                            <div @click="openstock()" v-show="timeData">

                                <fst 
                                    :timeData="timeData" 
                                    :code="code"
                                    :autoRefresh="true"
                                    :refreshInterval="60000"
                                    @refresh="handleRefresh"
                                    :stock_data="stock_data"
                                
                                />
                            </div>
                        </div>

                    </div>


                </div>

                
                <section class="section-stack" v-if="0">
                

                    <!-- 行情概述 -->
                    <article id="overview" class="overview" v-if="overviewContent">
                    <h2>行情概述</h2>
                    <p v-html="overviewContent"></p>
                    </article>


                    <!-- 主要章节 -->
                    <section id="logicList" class="section-stack">
                        <details
                        v-for="(section, index) in sections"
                        :key="index"
                        class="logic-card"
                        open=""
                        >
                        <summary aria-expanded="true">
                            <span class="icon" aria-hidden="true">
                            <img :src="section.icon" alt="">
                            </span>
                            <h3 class="summary-title">{{ section.title }}</h3>
                            <span class="chevron" aria-hidden="true"></span>
                        </summary>
                        <div class="logic-body" style="height: auto; opacity: 1;">
                            <!-- 引导语：遍历数组，每个段落一个 <p> -->
                                <p 
                                    v-for="(paragraph, idx) in section.intro" 
                                    :key="paragraph"
                                    class="section-intro"
                                    v-html="paragraph"
                                    ></p>
                            <p
                            v-for="(item, idx) in section.items"
                            :key="idx"
                            class="numbered-item"
                            >
                            <span class="item-marker">{{ idx + 1 }}.</span>
                            <span class="item-copy" v-html="item"></span>
                            </p>
                        </div>
                        </details>
                    </section>

                    <!-- 风险提醒独立模块 - 使用 article 结构 -->
                    <article v-if="riskSection" id="riskCard" class="risk-card"
                    :class="{ open: isRiskOpen }"
                    
                    >
                    <button
                        id="riskToggle"
                        class="risk-head"
                        type="button"
                        aria-expanded="true"
                        aria-controls="riskList"
                        @click="toggleRisk"
                    >
                        <span class="icon" aria-hidden="true">
                        <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-risk.svg" alt="">
                        </span>
                        <h3>{{ riskSection.title }}</h3>
                        <span class="chevron" aria-hidden="true"></span>
                    </button>
                    <div id="riskList" class="risk-list" :style="riskListStyle">
                        <div
                        v-for="(item, idx) in riskSection.items"
                        :key="idx"
                        >
                        <p class="risk-item" v-html="item"></p>
                        <span
                            v-if="idx < riskSection.items.length - 1"
                            class="risk-divider"
                            aria-hidden="true"
                        ></span>
                        </div>
                    </div>
                    </article>




                </section>

                <!-- AI 报告流式组件 -->
                <AiReportStream
                    :code="code"
                    :name="name"
                    :uId="user_id"
                    :initialMarkdown="cachedMarkdown"
                    @stream-error="handleStreamError"
                    @stream-done="handleStreamDone"
                />

            </div>


            <div v-if="ai_report_finish">



                <div class="data_update" v-if="!has_ai_report">
                    <span>数据更新</span>&nbsp;&nbsp;<span>{{update_time}}</span>
                </div>
                <div class="company_box" v-if="!has_ai_report">
                    <div class="grade_box">
                        <div class="company_chart">
                            <company_chart
                                    :quality="Math.ceil(overview.quality_score)"
                                    :institution="Math.ceil(overview.institution_score)"
                                    :industry="Math.ceil(overview.industry_score)"
                                    :valuation="Math.ceil(overview.valuation_score)"
                                    :trend="Math.ceil(overview.trend_score)"
                            />
                        </div>
                        <div class="grade">
                            <div class="grade_name">综合评分</div>
                            <div class="grade_number">{{Math.ceil(overview.total_score)}}</div>
                            <div class="grade_word">击败了<span>{{Math.ceil(overview.beat_percent*100)}}%</span>的个股</div>
                        </div>
                    </div>
                    <div class="company_quality">
                        <div class="company_quality_title">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/gs2.png"/>
                            <span class="big_title_common">公司质地</span>
                        </div>
                        <div class="company_quality_content">
                            <ul v-if="quality.msgs">
                                <li v-for="item in quality.msgs">
                                    <div class="point"></div>
                                    <p>
                                        <span v-for="i in item":class="{ 'point_tag': i.mark  }" >{{i.str}}</span>
                                    </p>
                                </li>
                            </ul>
                            <ul v-if="!quality.msgs">
                                <li>
                                    <div class="point"></div>
                                    <p>
                                        暂无公司质地
                                    </p>
                                </li>
                            </ul>
                            <div class="company_tag" v-if="quality.tags">{{quality.tags}}</div>
                        </div>
                    </div>
                    <div class="company_quality">
                        <div class="company_quality_title">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/dq2.png"/>
                            <span class="big_title_common">短期策略</span>
                        </div>
                        <div class="company_quality_content">
                            <ul v-if="strategy.msgs">
                                <li v-for="item in strategy.msgs">
                                    <div class="point blue"></div>
                                    <p>
                                        <span v-for="i in item">{{i.str}}</span>
                                    </p>
                                </li>
                            </ul>
                            <ul v-if="!strategy.msgs">
                                <li>
                                    <div class="point blue"></div>
                                    <p>
                                        暂无短期策略
                                    </p>
                                </li>
                            </ul>
                            <div class="company_tag tag_blue" v-if="strategy.tags">{{strategy.tags}}</div>
                        </div>
                    </div>
                </div>


                <div class="data_box" v-if="!has_ai_report && znzg_in">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">行业题材</span></div>
                    <div class="target_price_p" v-if="industryInfo.length > 0">
                        <h1>行业<span>取自申万一级行业和二级行业</span></h1>

                        <div class="plate_wrap">
                            <div class="plate_i" :class="[item.chg > 0 ?'red':'',item.chg < 0 ?'green':'']" v-for="item in industryInfo">
                                <h1>{{item.industryName}}</h1>
                                <span>{{parseF(item.chg)}}%</span>
                            </div>
                        </div>

                    </div>
                    <div class="target_price_p"  v-if="changeAreaTheme.length > 0">
                        <h1>题材<span>取最相关和有异动的题材</span></h1>

                        <div class="plate_wrap">
                            <div class="plate_i" :class="[item.chgPct > 0 ?'red':'',item.chgPct < 0 ?'green':'']" v-for="item in changeAreaTheme">
                                <i v-if="item.tag">{{item.tag}}</i>
                                <h1>{{item.themeName}}</h1>
                                <span>{{parseF(item.chgPct) }}%</span>
                            </div>
                        </div>
                    </div>
                    <div class="target_price_p2">
                        <p v-html="industryComment.replace(/<\d{6}>/g,'')"></p>
                        <p v-if="themeComment">
                            <span class="red">异动</span>
                            <span v-html="themeComment.replace(/<\d{6}>/g,'')"></span>
                        </p>
                    </div>

                </div>

                <div class="data_box" v-if="!has_ai_report">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">财务点评</span></div>
                    <div class="goodness">
                        <div class="goodness_title">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/smile.png">
                            <span>财务亮点</span>
                        </div>
                        <div class="goodness_content">
                            <ul v-if="finance_comment.highlight">
                                <li v-for="item in highlight"><div class="goodness_point goodness_content_blue"></div>{{item}}</li>
                            </ul>
                            <ul v-if="!finance_comment.highlight">
                                <li><div class="goodness_point goodness_content_blue"></div>暂无财务亮点</li>
                            </ul>
                        </div>
                    </div>
                    <div class="goodness">
                        <div class="goodness_title">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/cry.png">
                            <span class="goodness_title_blue">风险提示</span>
                        </div>
                        <div class="goodness_content">
                            <ul v-if="finance_comment.risk">
                                <li v-for="item in risk"><div class="goodness_point goodness_content_blue"></div>{{item}}</li>
                            </ul>
                            <ul v-if="!finance_comment.risk">
                                <li><div class="goodness_point goodness_content_blue"></div>暂无风险提示</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="data_box" v-if="!has_ai_report">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">机构目标价</span></div>
                    <div class="target_price">
                        <div class="target_price_content" v-if="insTargetPrice.comment_list ">
                            <span v-for="item in insTargetPrice.comment_list" :class="{'span_tag' : item.mark}">{{item.str}}</span>
                        </div>
                        <div class="target_price_content target_price_content_none" v-if="!insTargetPrice.comment_list ">
                            <span>暂无机构目标价</span>
                        </div>
                        <div class="target_price_chart" ref="chart" v-if="insTargetPrice.comment_list ">
                            <div class="target_price_chart_box" style="top: 0;" v-if="insTargetPrice.pct && insTargetPrice.avg - insTargetPrice.max != 0">
                                <div>最高目标价</div><div>{{insTargetPrice.max}}元</div>
                            </div>
                            <div class="target_price_chart_box" :style="{ bottom : min_bottom }" v-if="insTargetPrice.pct && insTargetPrice.avg - insTargetPrice.min !=0">
                                <div>最低目标价</div><div>{{insTargetPrice.min}}元</div>
                            </div>
                            <div :class="['target_price_chart_box',!insTargetPrice.pct ? 'target_price_chart_box_blue':'target_price_chart_box_red']"
                                :style="{top : avg_top }">
                                <div>目标均价</div><div :class="[!insTargetPrice.pct ? 'target_font_blue':'target_font_red']">{{insTargetPrice.avg}}元</div>
                            </div>
                            <div :class="['target_price_chart_box',!insTargetPrice.pct ? 'target_price_chart_box_red':'target_price_chart_box_blue']"
                                :style="{top : cur_top  }">
                                <div>当前价</div><div :class="[!insTargetPrice.pct ? 'target_font_red':'target_font_blue']">{{insTargetPrice.cur}}元</div>
                            </div>
                            <div class="target_price_chart_squre" ref="chartsqure" v-if="insTargetPrice.pct"
                                :style="{top : squre_top , height : squre_height}"
                            >
                                <div class="target_price_chart_squre_text">目标涨幅{{insTargetPrice.pct}}</div>
                                <div class="target_price_chart_squre_tag">
                                    <div></div><div></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="data_box" v-if="insHoldRatio">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">机构持股比例</span></div>
                    <div class="target_price">
                        <div class="target_price_content" v-if="insHoldRatio.hs">
                            <span v-for="item in insHoldRatio.hs" :class="{'span_tag' : item.mark}">{{item.str}}</span>
                        </div>
                        <div class="target_price_content target_price_content_none" v-if="!insHoldRatio.hs">
                            暂无机构持股比例
                        </div>
                        <div class="ratio_chart" v-if="insHoldRatio.hs">
                            <RatioChart :price="insHoldRatio.price" :ratio="insHoldRatio.ratio" />
                        </div>
                    </div>
                </div>
                <div class="data_box" v-if="insGradeResult">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">机构评级</span></div>
                    <div class="target_price" v-if="insGradeResult.grade > 0">
                        <div class="target_price_content">{{insGradeResult.comment}}</div>
                        <div class="target_price_content_chart">
                            <div class="target_price_content_chart_pos_box">
                                <div class="target_price_content_chart_pos" :style="{left:price_left+'%' }"></div>
                            </div>
                            <div class="target_price_content_chart_wrap">
                                <div class="target_price_content_chart_box">
                                    <div class="target_price_content_chart_box_color"></div>
                                    <div class="target_price_content_chart_box_word">卖出</div>
                                </div>
                                <div class="target_price_content_chart_box">
                                    <div class="target_price_content_chart_box_color color2"></div>
                                    <div class="target_price_content_chart_box_word">减持</div>
                                </div>
                                <div class="target_price_content_chart_box">
                                    <div class="target_price_content_chart_box_color color3"></div>
                                    <div class="target_price_content_chart_box_word">中性</div>
                                </div>
                                <div class="target_price_content_chart_box">
                                    <div class="target_price_content_chart_box_color color4"></div>
                                    <div class="target_price_content_chart_box_word">增持</div>
                                </div>
                                <div class="target_price_content_chart_box">
                                    <div class="target_price_content_chart_box_color color5"></div>
                                    <div class="target_price_content_chart_box_word">买入</div>
                                </div>
                            </div>
                        </div>
                        <div class="grade_table">
                            <div class="grade_table_title">
                                <span>名称</span>
                                <span>日期</span>
                                <span>评级</span>
                            </div>
                            <ul>
                                <li v-for="item in insGradeResult.item_list">
                                    <span>{{item.name}}</span>
                                    <span>{{item.date}}</span>
                                    <span :class="[item.content == '买入' ? 'grade_red': (item.content == '增持' ? 'grade_yellow' : 'grade_green' )]">{{item.content}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="target_price" v-if="insGradeResult.grade == 0">
                        <div class="target_price_content target_price_content_none">暂无机构评级</div>
                    </div>
                </div>
                <div class="data_box" v-if="!has_ai_report">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">主力资金</span></div>
                    <div class="target_price" v-if="moneyGraph.hs">
                        <div class="target_price_content">{{moneyGraph.hs}}</div>
                        <mainCapital
                                :xl="parseInt(mainCapital1.xl)"
                                :l="parseInt(mainCapital1.l)"
                                :m="parseInt(mainCapital1.m)"
                                :s="parseInt(mainCapital1.s)"
                        >

                        </mainCapital>
                    </div>
                    <div class="target_price" v-if="!moneyGraph.hs">
                        <div class="target_price_content target_price_content_none">暂无主力资金</div>
                    </div>
                </div>
                <div class="data_box" v-if="!has_ai_report">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">技术分析</span></div>
                    <div class="target_price">
                        <div class="target_price_content" v-if="techAspect.aspect_comment">{{techAspect.aspect_comment}}</div>
                        <div :class="[!techAspect.aspect_comment && !techAspect.k_node_list ? 'target_price_content_none':'' ,'target_price_content']" v-if="!techAspect.aspect_comment">暂无技术分析</div>
                    <div class="technical_analysis" v-if="techAspect.k_node_list">
                        <div class="technical_analysis_title">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/tri.png"/>
                            压力与支撑</div>
                        <div class="technical_analysis_chart">
                            <Kchart :k_node_list="techAspect.k_node_list" />
                        </div>
                    </div>
                    <div class="technical_analysis" v-if="0 && techAspect.signals">
                        <div class="technical_analysis_title">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/tri.png"/>
                            当前技术信号/形态
                        </div>
                        <div class="technical_analysis_box">
                            <span v-for="item in techAspect.signals" :class="[item.type == 'SHORT' ? 'down_span':(item.type == 'HOLD' ? 'down_span':'hold_span')]">
                                {{item.name}}
                            </span>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="data_box" v-if="dragonTiger">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">龙虎榜</span></div>
                    <div class="target_price">
                        <div class="target_price_content longhu" v-if="dragonTiger.hs != '最近30日未登上龙虎榜'">{{dragonTiger.hs}}</div>
                        <div class="longhu_box" v-if="dragonTiger.hs != '最近30日未登上龙虎榜'">
                            <div class="longhu_range">
                                <div>{{dragonTiger.rank_date}}</div>
                                <div class="longhu_rise" v-if="dragonTiger.chg_pct >= 0">
                                    <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/zhang.png" />
                                    <span>涨幅：</span>
                                    <span class="longhu_rise_red">+{{(dragonTiger.chg_pct*100).toFixed(2)}}%</span>
                                </div>
                                <div class="longhu_rise longhu_fall" v-if="dragonTiger.chg_pct < 0">
                                    <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/die.png" />
                                    <span>跌幅：</span>
                                    <span class="longhu_rise_green">{{(dragonTiger.chg_pct*100).toFixed(2)}}%</span>
                                </div>
                            </div>
                            <div class="longhu_total">
                                <div><p>买入(万元)</p><p class="total_num total_num_buy">{{(dragonTiger.total_buy/10000).toFixed(2)}}</p></div>
                                <div><p>卖出(万元)</p><p class="total_num total_num_sell">{{(dragonTiger.total_sell/10000).toFixed(2)}}</p></div>
                                <div><p>净买(万元)</p><p class="total_num total_num_net">{{(dragonTiger.total/10000).toFixed(2)}}</p></div>
                            </div>
                            <div class="longhu_reason">上榜理由：{{dragonTiger.reason}}</div> 
                            <div class="expand" v-show="longhu_expand == 0" @click="expand"><img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/open.png"/>展开</div>
                            <div v-show="longhu_expand == 1">
                                <div class="longhu_table">
                                    <div class="longhu_table_title">
                                        <div class="longhu_table_buy5 longhu_red">买入前五</div>
                                        <div>买入(万)</div><div class="longhu_table_sell">卖出(万)</div>
                                    </div>
                                    <ul>
                                        <li v-for="item in dragonTiger.buy_list">
                                            <div class="longhu_table_buy5">{{item.sales}}</div>
                                            <div class="longhu_red">{{(item.buyValue/10000).toFixed(2)}}</div>
                                            <div class="longhu_table_sell longhu_blue">{{(item.sellValue/10000).toFixed(2)}}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="longhu_table">
                                    <div class="longhu_table_title">
                                        <div class="longhu_table_buy5 longhu_green">卖出前五</div><div>买入(万)</div><div class="longhu_table_sell">卖出(万)</div>
                                    </div>
                                    <ul>
                                        <li v-for="item in dragonTiger.sell_list">
                                            <div class="longhu_table_buy5">{{item.sales}}</div>
                                            <div class="longhu_red">{{(item.buyValue/10000).toFixed(2)}}</div>
                                            <div class="longhu_table_sell longhu_blue">{{(item.sellValue/10000).toFixed(2)}}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="expand" v-show="longhu_expand == 1" @click="expand"><img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/close.png"/>收起</div>
                            </div>
                        </div>
                        <div class="target_price_content target_price_content_none " v-if="dragonTiger.hs == '最近30日未登上龙虎榜'">最近30日未登上龙虎榜</div>
                    </div>
                </div>


                <div class="data_box" v-if="!has_ai_report">
                    <div class="data_box_title"><span class="big_title_common big_title_margin">融资融券</span></div>
                    <div class="target_price">
                        <div class="target_price_content" v-if="finSecGraph.fin_comment">{{finSecGraph.fin_comment}}</div>
                        <div class="target_price_content target_price_content_none" v-if="!finSecGraph.fin_comment">暂无融资融券</div>
                        <div class="financing_chart" v-if="finSecGraph.fin_comment">
                            <FinancingChart :node_list="finSecGraph.node_list" :sum_list="finSecGraph.sum_list" :name="name" />
                        </div>
                    </div>
                </div>




                <div class="risk_statement">
                    智能诊断内容基于大数据智能生成，不构成投资建议，风险自担
                </div>
            </div>

        </div>
        <!-- 未购买 -->
        <div class="not_purchased" v-if="purchased == 0">
            <div class="not_purchased_box">
                <div class="not_name">{{name}}({{symbol}})</div>
                <div class="not_situation">
                    <span></span>&nbsp;&nbsp;&nbsp;<span></span>
                </div>

                <div class="not_trait">
                    <div >
                        <div class="not_trait_img">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/dpzd2.png" class="img_one"></div>
                            <div class="not_trait_word">大数据诊断</div>
                            <div class="not_trait_word">多维数据</div>
                            <div class="not_trait_word">透视个股真实盘面状态</div>
                        </div>
                    <div >
                        <div class="not_trait_img">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/rgzn2.png" class="img_two">
                        </div>
                        <div class="not_trait_word">大模型多因子分析</div>
                        <div class="not_trait_word">全景扫描同赛道龙头</div>
                        <div class="not_trait_word">捕捉题材趋势变化</div>
                    </div>
                    <div >
                        <div class="not_trait_img">
                            <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/jyjy2.png" class="img_three">
                        </div>
                        <div class="not_trait_word">AI中短线评测</div>
                        <div class="not_trait_word">拆解行情脉络</div>
                        <div class="not_trait_word">读懂主力资金博弈</div>
                    </div>
                </div>
                <!--task-->
                <a v-if="!is_from_agq && !is_from_kd && !is_from_zf" :href="'?kind=XNZG&stock_code='+symbol+'#AiGuPiao_ThirdPay'" class="not_btn">
                    查看此诊股 只需5金币
                </a>
                <p v-if="!is_from_agq && !is_from_kd && !is_from_zf">购买后24小时内有效</p>

                <a v-if="is_from_agq" href="javascript:;" class="not_btn">
                    开通任意圈子会员 即可免费使用
                </a>
                <a v-if="is_from_kd" href="javascript:;" class="not_btn">
                    开通任意星球会员 即可免费使用
                </a>
                <a v-if="is_from_zf" href="javascript:;" class="not_btn">
                    开通任意圈子会员 即可免费使用
                </a>

                <p v-if="is_from_agq" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">爱股圈小秘书</a>
                </p>
                <p v-if="is_from_kd" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">星球小秘书</a>
                </p>
                <p v-if="is_from_zf" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">中富通小秘书</a>
                </p>
            </div>
        </div>
        <!-- 暂无诊股 -->
        <div class="none" v-if="purchased == 2">
            <div class="none_img"><img :src="require('@/assets/images/znzg/none.png')"></div>
            <p>暂无此诊股...</p>
        </div>
    </div>

</template>

<script>
import "@/utils/flexible";
import company_chart from './charts/Company_chart.vue'
import RatioChart from './charts/RatioChart.vue'
import Kchart from './charts/Kchart.vue'
import KLine from './charts/KLineWithMA.vue'
import fst from './charts/fst.vue'
import FinancingChart from './charts/FinancingChart.vue'
import MainCapital from './charts/MainCapital.vue'
import Api from "@/api/Intelligent_diagnosis_stock/index";
import AiReportStream from './charts//AiReportStream.vue';


    import * as echarts from 'echarts'
    export default {
        name: "index",
        components:{
          company_chart,
          RatioChart,
          Kchart,
          KLine,
          fst,
          FinancingChart,
          MainCapital,
          AiReportStream,
        },
        data(){
            return{
                // 兼容两种传参格式：斜杠拼接 /uid/xxx/symbol/xxx/name/xxx 与 问号拼接 ?u_id=xxx&symbol=xxx&name=xxx
                user_id:this.$route.params.uid || this.getQueryVariable('u_id') || this.getQueryVariable('uid') || '',
                symbol:this.$route.params.id || this.getQueryVariable('symbol') || '',
                name:decodeURI(this.$route.params.name || this.getQueryVariable('name') || ''),
                purchased : 3, //是否为购买，1为是,0为未购买，2是暂无此诊股
                longhu_expand : 0, //是否已经展开龙虎榜
                overview:'',// 综合得分
                quality:'', //公司质地
                strategy:'',// 短期策略
                dragonTiger:'',//龙虎榜
                finSecGraph:'', //融资融券
                moneyGraph:'', //主力资金
                techAspect:'', //技术分析
                insGradeResult:'',//  机构评级
                insHoldRatio:'',//  机构持股比例
                insTargetPrice:'',//机构目标价
                finance_comment:'',//财务点评
                highlight:'',//财务亮点
                risk:'',//风险提示
                update_time:'',//更新时间
                avg_top :0,
                cur_top :0,
                avg_bottom :0,
                min_bottom :0,
                squre_height:0,
                squre_top:0,
                mainCapital1:{},//主力资金
                price_left:0,

                is_from_agq:false,//来自爱股圈
                is_from_kd: false, // 来自科德
                is_from_zf: false, // 来自中福

                znzg_in :false,
                changeAreaTheme:[],
                industryInfo:[],
                industryComment:'',
                themeComment:'',


                // sections: [],
                // riskSection: null,
                // overviewContent:'',
                // isRiskOpen: true, // 默认展开

                stock_data:null,//股票当前数据
                stockData:null,//k线图
                timeData:null,

                chartType: 'daily',     // 'time' 或 'kline'
                loading: false,
                code:'',//后端返回完整股票代码


                has_ai_report:true,//存在ai报告
                ai_report_finish:false,//ai报告是否生成结束
                cachedMarkdown:''//ai报告缓存内容

            }

        },
        created() {

            this.is_from_agq = location.href.includes('is_from_agq');
            this.is_from_kd = location.href.includes('is_from_kd');
            this.is_from_zf = location.href.includes("is_from_zf");
        },
        mounted(){


            

            let data = {user_id:this.user_id, symbol:this.symbol};
            if(this.is_from_agq){
                data.is_from_agq = 'yes';
            }
            if(this.is_from_kd) {
                data.is_from_kd = 'yes'
            }
            if(this.is_from_zf) {
                data.is_from_zf = "yes";
            }

            
            this.stockDetail(data);


            //todo 开发调试时注释
            // this.purchased = 1;
            // this.code = 'sh688825';            
            // this.stockDetail_s();
            // this.stockDetail_k();
            // this.cachedMarkdown = "# 浦发银行（600000）近期震荡分化 6月创60日新低（截至2026年7月15日）\n浦发银行近期整体呈现**震荡分化、多空力量相对均衡**的走势，6月29日盘中创下8.63元的60日新低后股价逐步修复，截至7月中旬股价围绕9元一线波动。基本面端一季度营收、净利润小幅双增，支撑估值底；资金面则呈现主力资金阶段性流出、融资资金小幅加仓的分歧格局，当前交易主线围绕银行板块资产质量修复与高股息分红展开。\n\n## 一、走势复盘：60日新低后窄幅震荡，多空博弈收敛\n- 6月29日盘中股价下探8.63元，创下近60个交易日新低，当日跌幅1.48%，短期抛压集中释放。\n- 新低之后股价未继续大幅下挫，逐步回升至9元附近震荡，近20个交易日主力资金成本约8.97元，当前价格贴近机构持仓成本线。\n- 技术面指标暂无明确趋势性信号，短期市场关注意愿保持中性，未出现极端放量或缩量的异动特征。\n\n## 二、基本面支撑：一季报营收净利双增，资产质量持续向好\n- 据2026年一季报披露，报告期内集团实现营业收入465.73亿元，同比增长1.42%；归母净利润178.61亿元，同比增长1.49%，实现稳健开局。\n- 资产负债结构持续优化，报告期末存款总额较上年末增长3.52%，活期存款占比较上年末提升1.97个百分点，利息净收入同比增长12.43%，负债端成本管控成效显现。\n- 资产质量保持“双降”态势，不良贷款率1.23%，较上年末下降0.03个百分点；拨备覆盖率204.79%，较上年末上升4.07个百分点，风险缓冲垫进一步增厚。\n\n## 三、资金面分歧：主力阶段性流出，融资资金逆势加仓\n- 据证券之星披露，6月29日前10个交易日内，主力资金累计净流出4757.25万元，短期机构资金呈现阶段性兑现动作，是股价创下60日新低的直接推手之一。\n- 同期融资余额累计增加6513.27万元，融资资金呈现逆势布局态势；截至7月13日，公司融资融券差额为37.76亿元，占流通盘比例1.23%，较前一交易日略有上升。\n- 据东方财富网数据，当前机构参与度为39.77%，属于中度控盘区间，主力资金尚未出现大幅集中流入或流出的极端信号，资金整体处于观望状态。\n\n## 四、近期事件催化：2025年度权益分派落地，高股息属性强化\n- 据7月10日公司发布的2025年年度权益分派实施公告，年度分红方案进入落地执行阶段，持续兑现银行板块高股息属性，对长期配置资金形成一定吸引力。\n- 公司科技金融贷款余额保持1万亿元以上，绿色信贷余额达7383.57亿元，普惠两增贷款规模5367.28亿元，持续契合国家政策导向，市场对其长期业务结构优化形成稳定预期。\n\n## 风险提示\n银行板块整体息差仍面临行业性收窄压力，可能对后续利息净收入增速形成约束。宏观经济复苏节奏若不及预期，可能导致部分区域信贷资产质量出现波动。近期主力资金未呈现明确持续流入态势，股价短期向上弹性或相对有限。行业板块整体估值修复行情若出现回调，个股或随板块同步波动。\n\n信息仅供参考，不构成投资建议。";



        },
        methods:{
            getQueryVariable(variable) {
                var query = location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return '';
            },
            handleStreamError(msg) {
                // 可显示 toast 提示，或降级到旧版诊股
                console.error('流式报告错误:', msg);
                this.ai_report_finish = true;
            },
            handleStreamDone() {
                console.log('报告生成完成');
                this.ai_report_finish = true;
            },
            handleRefresh() {
                this.stockDetail_fs()
            },
            switchChart(type) {
                if (this.chartType === type) return  // 相同不切换
                this.loading = true
                this.chartType = type;
                if(this.chartType == 'time'){
                    this.stockDetail_fs();
                }
                else{
                    this.stockDetail_k();
                }
                
            },
            openstock(){
                location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${this.code}&name=${this.name}`;
            },
            async stockDetail_fs(){
                let res = await Api.getfs({
                    code:this.code,
                });
                if(res){
                    this.timeData = res;
                }
                this.loading = false
            },
            async stockDetail_k(){
                let res = await Api.getk({
                    code:this.code,
                    type:this.chartType,
                });
                if(res){
                    this.stockData = res;
                }
                this.loading = false


            },
            async stockDetail_s(){
                let _code = this.code;
                let data = await Api.getAStock({
                    list: _code,
                });
                if(data) {
                    let spl_data = data[_code].split(',')
                    this.stock_data = {
                        chg: spl_data[2],
                        chg_pct: (spl_data[3]* 1).toFixed(2),
                        price: spl_data[0],
                        y_close:spl_data[1],
                        high:spl_data[5],
                        low:spl_data[6],
                    }
                    //this.stockDetail_fs();
                }
            },


            // toggleRisk() {
            //     this.isRiskOpen = !this.isRiskOpen
            // },
            // parseMarkdown(markdown) {
            //     const lines = markdown.split('\n')
                
            //     let overviewContent = ''
            //     let sections = []
            //     let riskItems = []
            //     let disclaimer = ''
                
            //     let currentSection = null
            //     let currentItems = []
            //     let currentIntro = []
            //     let isCollectingItems = false
            //     let isRiskSection = false
            //     let isOverview = false

            //     // 有效章节数字映射
            //     const validSectionNumbers = ['一', '二', '三', '四', '五', '六']
            //     const numberToIndex = { '一': 0, '二': 1, '三': 2, '四': 3, '五': 4, '六': 5 }

            //     const iconMap = {
            //         '一': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg',
            //         '二': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-basic.svg',
            //         '三': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-amoled.svg',
            //         '四': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-car.svg',
            //         '五': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-fund.svg',
            //         '六': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-plus.svg'
            //     }

            //     const processText = (text) => {
            //         let content = text
            //         content = content.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            //         content = content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
            //         return content
            //     }

            //     // 判断章节是否在有效范围内（一 到 六）
            //     const isValidSection = (num) => {
            //         return validSectionNumbers.includes(num)
            //     }

            //     for (let i = 0; i < lines.length; i++) {
            //         const line = lines[i].trim()
            //         if (!line) continue

            //         // ===== 检测风险提示标题 =====
            //         const riskMatch = line.match(/^#{2,3}\s+(风险提示.*)$/)
            //         if (riskMatch) {
            //         if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
            //             sections.push({
            //             title: currentSection,
            //             intro: [...currentIntro],
            //             items: [...currentItems],
            //             icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
            //             })
            //         }
            //         currentSection = null
            //         currentItems = []
            //         currentIntro = []
            //         isCollectingItems = false
            //         isRiskSection = true
            //         isOverview = false
            //         continue
            //         }

            //         // ===== 检测章节标题（只识别 一 到 六） =====
            //         const sectionMatch = line.match(/^##\s+([一二三四五六七八九十]+)、(.+)$/)
            //         if (sectionMatch) {
            //         const num = sectionMatch[1]
            //         // 只处理 一 到 六 的章节，超出部分忽略
            //         if (!isValidSection(num)) {
            //             // 如果当前正在收集内容，先保存之前的
            //             if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
            //             sections.push({
            //                 title: currentSection,
            //                 intro: [...currentIntro],
            //                 items: [...currentItems],
            //                 icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
            //             })
            //             }
            //             // 清空状态，停止收集（超出范围的章节不展示）
            //             currentSection = null
            //             currentItems = []
            //             currentIntro = []
            //             isCollectingItems = false
            //             isRiskSection = false
            //             isOverview = false
            //             continue
            //         }

            //         // 保存上一个章节
            //         if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
            //             sections.push({
            //             title: currentSection,
            //             intro: [...currentIntro],
            //             items: [...currentItems],
            //             icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
            //             })
            //         }
            //         currentSection = `${sectionMatch[1]}、${sectionMatch[2]}`
            //         currentItems = []
            //         currentIntro = []
            //         isCollectingItems = true
            //         isRiskSection = false
            //         isOverview = false
            //         continue
            //         }

            //         // ===== 检测免责声明 =====
            //         if (line.includes('信息仅供参考')) {
            //         disclaimer = line
            //         continue
            //         }

            //         // ===== 检测概述 =====
            //         if (!isOverview && !isRiskSection && !currentSection && line && !line.match(/^#/)) {
            //         overviewContent = processText(line)
            //         isOverview = true
            //         continue
            //         }

            //         // ===== 处理风险部分 =====
            //         if (isRiskSection) {
            //         const bulletMatch = line.match(/^-\s+(.+)$/)
            //         if (bulletMatch) {
            //             riskItems.push(processText(bulletMatch[1]))
            //             continue
            //         }
            //         const numMatch = line.match(/^(\d+)\.\s+(.+)$/)
            //         if (numMatch) {
            //             riskItems.push(processText(numMatch[2]))
            //             continue
            //         }
            //         if (line && !line.match(/^#/)) {
            //             if (riskItems.length > 0) {
            //             const last = riskItems[riskItems.length - 1]
            //             if (!/[。；;！?！]$/.test(last)) {
            //                 riskItems[riskItems.length - 1] = last + ' ' + processText(line)
            //                 continue
            //             }
            //             }
            //             riskItems.push(processText(line))
            //         }
            //         continue
            //         }

            //         // ===== 处理章节内容 =====
            //         if (isCollectingItems && currentSection) {
            //         const bulletMatch = line.match(/^-\s+(.+)$/)
            //         if (bulletMatch) {
            //             currentItems.push(processText(bulletMatch[1]))
            //             continue
            //         }
            //         const numMatch = line.match(/^(\d+)\.\s+(.+)$/)
            //         if (numMatch) {
            //             currentItems.push(processText(numMatch[2]))
            //             continue
            //         }
            //         // ===== 纯文本段落：加入 intro 数组 =====
            //         if (line && !line.match(/^#/) && !line.match(/^-\s+/) && !line.match(/^\d+\.\s+/)) {
            //             const processed = processText(line)
            //             if (currentItems.length === 0) {
            //             currentIntro.push(processed)
            //             } else {
            //             const last = currentItems[currentItems.length - 1]
            //             if (!/[。；;！?！]$/.test(last)) {
            //                 currentItems[currentItems.length - 1] = last + ' ' + processed
            //             }
            //             }
            //         }
            //         }
            //     }

            //     // ===== 保存最后一个章节 =====
            //     if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
            //         sections.push({
            //         title: currentSection,
            //         intro: [...currentIntro],
            //         items: [...currentItems],
            //         icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
            //         })
            //     }

            //     return {
            //         overviewContent,
            //         sections,
            //         riskSection: riskItems.length > 0 ? { title: '风险提示', items: riskItems } : null,
            //         disclaimer
            //     }
            // },
            // validateMarkdown(markdown) {
            //     // 1. 必须有一级标题
            //     const hasTitle = /^#\s+.+/m.test(markdown)
                
            //     // 2. 必须有至少一个章节标题（## 一、 到 ## 六、）
            //     const hasSection = /^##\s+[一二三四五六]+、.+$/m.test(markdown)
                
            //     // 3. 必须有风险提示
            //     const hasRisk = /^#{2,3}\s+风险提示/m.test(markdown)

            //     return hasTitle && hasSection && hasRisk;
            // },
            expand(){
                this.longhu_expand = !this.longhu_expand;
            },
            parseF(val){
                val = (parseFloat(val) * 100).toFixed(2);
                if(val > 0) val = '+'+val;
                return val;
            },
            async stockDetail(opt){
                let res = await Api.stockDetail(opt);
                console.log(res)
                if(res.code == 1001) {
                    //暂无此诊股
                    this.purchased = 2;
                }
                else if(res.code == 1002 || res.code == 1003 || ( res.code == 1004 && (this.is_from_agq || this.is_from_kd || this.is_from_zf) ) ){
                    //购买的产品已过期，请重新购买 or请先购买产品
                    this.purchased = 0;
                }
                else if(res.code == 0){
                    this.purchased = 1;

                    let data = res.data;
                    this.code = data.code;//在用

                    //图表直接生成
                    this.stockDetail_s();
                    this.stockDetail_k();

                    // //ai_report这个不用了，替换为新逻辑 && this.validateMarkdown(data.ai_report.content)
                    if(data.ai_report && data.ai_report.content){
                        let markdown = data.ai_report.content;
                        // 有历史报告且未过期 -> 直接展示缓存，不触发流式生成
                        this.cachedMarkdown = markdown; // 传给子组件
                        this.ai_report_finish = true;

                    }
                    else{
                        this.cachedMarkdown = '';
                    }


                    // let short = data.short;//在用
                    // let institutions = data.institutions;//在用
                    // this.insGradeResult = institutions && institutions.insGradeResult;//在用
                    // this.insHoldRatio = institutions && institutions.insHoldRatio;//在用
                    // this.dragonTiger = short && short.dragonTiger;//在用


                    // let synthesis = data.synthesis;
                    // this.insTargetPrice = institutions.insTargetPrice;
                    // this.overview = synthesis.overview;
                    // this.quality = synthesis.quality;
                    // //this.risk = synthesis.risk; 
                    // this.strategy = synthesis.strategy;
                    // this.update_time = synthesis.update_time;
                    // this.finSecGraph = short.finSecGraph;
                    // this.moneyGraph = short.moneyGraph;
                    // this.techAspect = short.techAspect;






                    // console.log('znzg',data.znzg)
                    // if(data.znzg.message == "success"){
                    //     this.znzg_in = true;
                    //     let _data = data.znzg.data;
                    //     this.changeAreaTheme = _data.changeAreaTheme;
                    //     this.industryInfo = _data.industryInfo;
                    //     this.industryComment = _data.industryComment;
                    //     this.themeComment = _data.themeComment;
                    // }



                    // if(this.insGradeResult.comment.indexOf("以增持为主")>-1){
                    //     this.price_left = 75;
                    // }else if(this.insGradeResult.comment.indexOf("以买入为主")>-1){
                    //     this.price_left = 85;
                    // }else if(this.insGradeResult.comment.indexOf("以卖出为主")>-1){
                    //     this.price_left = 15;
                    // }else if(this.insGradeResult.comment.indexOf("以减持为主")>-1){
                    //     this.price_left = 30;
                    // } else if(this.insGradeResult.comment.indexOf("以中性为主")>-1){
                    //     this.price_left = 48;
                    // }

                    // this.mainCapital1 = this.moneyGraph.mainCapital;

                    // this.finance_comment = data.finance_comment;
                    // if(this.finance_comment.highlight) this.highlight = this.finance_comment.highlight.split('\n');
                    // if(this.finance_comment.risk) this.risk = this.finance_comment.risk.split('\n');
                    // if(!this.insTargetPrice.pct){
                    //     this.$nextTick(()=> {
                    //         console.log(this.$refs.chart)
                    //         let chart_h = this.$refs.chart.offsetHeight;
                    //         this.avg_top = chart_h + 'px';
                    //         this.cur_top = 0;
                    //     })
                    // }
                    // else {
                    //     this.$nextTick(()=>{
                    //         console.log(this.$refs.chart)
                    //         let chart_h = this.$refs.chart.offsetHeight;
                    //         let chartsqure_h = this.$refs.chartsqure.offsetHeight;
                    //         let price = this.insTargetPrice;
                    //         let range,real_h,avg_h;
                    //         if(price.ceil == "最高目标价"){
                    //             if(price.cur - price.avg > 0){
                    //                 range = price.max - price.min;
                    //                 real_h = (price.max - price.cur) / range * chart_h;
                    //                 this.squre_height = real_h -1 +'px';
                    //                 this.squre_top = 0 +'px';
                    //                 this.cur_top = real_h  + 'px';
                    //                 avg_h = (price.max - price.avg) / range * chart_h;
                    //                 if(avg_h - real_h < chartsqure_h){
                    //                     avg_h = real_h + chartsqure_h;
                    //                 }
                    //                 this.avg_top = avg_h +'px';
                    //             }

                    //         }
                    //         else if(price.ceil == "平均目标价"){

                    //             if(price.min - price.cur > 0){
                    //                 range = price.max - price.cur;
                    //                 real_h = (price.avg - price.cur) / range * chart_h;
                    //                 avg_h = (price.max - price.avg) / range * chart_h;
                    //                 let min_h = (price.min - price.cur) / range * chart_h;
                    //                 if(real_h < chartsqure_h){
                    //                     real_h = chartsqure_h;
                    //                 }
                    //                 this.avg_top = avg_h +'px';
                    //                 this.squre_height = real_h -1  +'px';
                    //                 this.squre_top = avg_h + 1 +'px';
                    //                 this.cur_top = chart_h + 'px';
                    //                 this.min_bottom = min_h + 'px';
                    //             }
                    //             else{
                    //                 console.log(0)
                    //                 range = price.max - price.min;
                    //                 real_h = (price.avg - price.cur) / range * chart_h;
                    //                 avg_h = (price.max - price.avg) / range * chart_h;
                    //                 if(real_h < chartsqure_h){
                    //                     real_h = chartsqure_h;
                    //                 }
                    //                 this.avg_top = avg_h +'px';
                    //                 this.squre_height = real_h -1 +'px';
                    //                 this.squre_top = avg_h + 1 +'px';
                    //                 this.cur_top = real_h + avg_h + 'px';
                    //             }
                    //         }


                    //     })

                    // }
                }
                else {
                    //其他报错 也显示无诊股
                    this.purchased = 2;
                }

            },
            funToApp(funName, opt) {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                var data = null;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    if (window.android) {
                        console.log("安卓APP---" + funName, ...opt);
                        data = window.android[funName] && window.android[funName](...opt);
                    }
                } else if (isiOS) {
                    console.log("IOS---" + funName, [...opt]);
                    // data = window[funName] && window[funName](...opt);
                    data = window.webkit && window.webkit.messageHandlers[funName].postMessage([...opt])
                }
                return data;
            }
            

        },
        computed: {
        riskListStyle() {
            return this.isRiskOpen 
                ? { height: 'auto', opacity: 1 } 
                : { height: 0, opacity: 0, overflow: 'hidden' }
            }
    },
    }
</script>

<style lang="scss">
/* 不加 scoped，让变量真正全局生效 */
:root {
  color-scheme: light;
  --page-bg: #f7f5f6;
  --card-bg: #ffffff;
  --card-shadow: 0 2px 6px rgba(90, 30, 30, 0.06);
  --text: #333333;
  --muted: #9aa3b2;
  --link: #1d88d0;
  --topic: #1d88d0;
  --icon-bg: #fdecec;
  --icon: #ff8a8a;
  --highlight: #fff3a8;
  --risk-bg: #fffaf4;
  --risk-icon-bg: #feedc5;
  --risk-text: #8a4b0a;
  --risk-line: rgba(235, 162, 81, 0.18);
}
</style>
<style lang="scss" scoped>
    * {
      box-sizing: border-box;
    }

    html {
      min-height: 100%;
      background: #f7f5f6;
    }

    body {
      margin: 0;
      min-height: 100vh;
      display: flex;
      justify-content: center;
      color: var(--text);
      background: #f7f5f6;
      font-family: "Noto Sans SC", -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Segoe UI", sans-serif;
      letter-spacing: 0;
    }

    .stock{
        min-height: 100vh;
        background: #f7f5f6;
    }


</style>
<style lang="scss" >

.phone_znzg::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 0;
    width: min(100vw, 375px);
    height: 260px;
    transform: translateX(-50%);
    pointer-events: none;
    background: linear-gradient(180deg, #fde5e5 0, rgba(253, 229, 229, 0) 240px);
}


.phone_znzg {
    width: min(100vw, 375px);
    position: relative;
    isolation: isolate;
    background: var(--page-bg);
    padding: 12px 12px;
}
@media (max-width: 360px) {
    .phone_znzg {
    padding-left: 10px;
    padding-right: 10px;
    }
}

.phone_znzg{
    .section-stack {
      position: relative;
      z-index: 1;
      display: grid;
      gap: 8px;
    }

    .stock-tools {
      display: grid;
      gap: 8px;
      padding: 10px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.84);
      box-shadow: var(--card-shadow);
    }

    .search-box {
      height: 40px;
      display: grid;
      grid-template-columns: 18px minmax(0, 1fr);
      align-items: center;
      gap: 8px;
      padding: 0 10px;
      border: 1px solid rgba(235, 235, 235, 0.92);
      border-radius: 10px;
      background: #ffffff;
      color: var(--muted);
      font-size: 14px;
    }

    .search-box input {
      width: 100%;
      border: 0;
      outline: 0;
      background: transparent;
      color: var(--text);
      font: inherit;
      min-width: 0;
    }

    .search-box input::placeholder {
      color: #a7afbb;
    }

    .switch-row {
      display: grid;
      grid-template-columns: 36px minmax(0, 1fr) 36px;
      gap: 8px;
      align-items: center;
    }

    .switch-button {
      width: 36px;
      height: 34px;
      border: 0;
      border-radius: 9px;
      background: #ffffff;
      color: #7d8794;
      font-size: 24px;
      line-height: 1;
      box-shadow: inset 0 0 0 1px rgba(235, 235, 235, 0.94);
    }

    .stock-count {
      min-width: 0;
      color: #727b88;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .stock-strip {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: minmax(106px, 128px);
      gap: 8px;
      overflow-x: auto;
      padding-bottom: 2px;
      scrollbar-width: none;
    }

    .stock-strip::-webkit-scrollbar {
      display: none;
    }

    .stock-option {
      min-height: 54px;
      border: 0;
      border-radius: 10px;
      background: #ffffff;
      box-shadow: inset 0 0 0 1px rgba(235, 235, 235, 0.94);
      padding: 8px 10px;
      color: var(--text);
      text-align: left;
    }

    .stock-option.active {
      background: #fff4f4;
      box-shadow: inset 0 0 0 1px rgba(255, 132, 132, 0.42);
    }

    .stock-option strong {
      display: block;
      font-size: 14px;
      line-height: 1.25;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .stock-option span {
      display: block;
      margin-top: 4px;
      color: var(--muted);
      font-size: 11px;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .empty {
      padding: 18px 12px;
      color: var(--muted);
      text-align: center;
      font-size: 13px;
    }

    .overview_k{
        position: relative;
        margin-bottom: 10px;
    }

    .overview,
    .logic-card,
    .risk-card {
      width: 100%;
      border-radius: 12px;
      box-shadow: var(--card-shadow);
      box-sizing: border-box;
    }

    .overview {
      display: grid;
      gap: 8px;
      padding: 12px;
      background: var(--card-bg);
    }

    .overview_kh{
        .overview_kh1,.overview_kh2{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            color: #333333;
            margin-bottom: 10px;

            .red{
                color: #CB382D;
            }

            .green{
                color: #659957;
            }
        }
        .overview_kh2{
            font-weight: 400;
            font-size: 13px;
            color: #939393;
            margin-bottom: 5px;
        }
    }

    .chart-wrapper{
        position: relative;
        .loading-overlay{
            display: flex;
            width: 15px;
            height: 15px;
            position: absolute;
            left: 50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }
    .chart-tabs{

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 5px;
        height: 32px;
        background: #F5F6F7;
        border-radius: 8px;


        .tab-btn{
            font-size: 13px;
            display: flex;
            align-items: center;
            text-align: center;
            color:#636363;
            border: none;
            height: 22px;
            padding: 0 20px;
            background: unset;
        }

        .active{
            /* 分时 */

            background: #fff;
            font-weight: 600;
            color: #333333;
            border-radius: 8px;


        }
    }

    .overview h2 {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
    }

    .overview p {
      margin: 0;
      font-size: 14px;
      line-height: 1.6;
      font-weight: 400;
      word-break: break-word;
    }

    .overview a,
    .blue {
      color: var(--link);
      text-decoration: none;
    }

    .overview strong {
      color: var(--text);
      font-weight: 800;
    }

    .topic {
      color: var(--text);
      font-weight: 700;
    }

    .logic-card,
    .risk-card {
      overflow: hidden;
      background: var(--card-bg);
    }

    details {
      display: block;
    }

    summary {
      min-height: 64px;
      display: grid;
      grid-template-columns: 30px minmax(0, 1fr) 22px;
      gap: 12px;
      align-items: center;
      padding: 12px;
      list-style: none;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }

    summary::-webkit-details-marker {
      display: none;
    }

    .icon {
      width: 30px;
      height: 30px;
      display: grid;
      place-items: center;
      align-self: center;
      border-radius: 9px;
      background: var(--icon-bg);
      color: var(--icon);
    }

    .icon img {
      width: 20px;
      height: 20px;
      display: block;
    }

    .summary-title {
      margin: 0;
      min-width: 0;
      color: var(--text);
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
      word-break: break-word;
    }

    .chevron {
      width: 9px;
      height: 9px;
      justify-self: center;
      border-right: 2px solid var(--muted);
      border-bottom: 2px solid var(--muted);
      transform: rotate(45deg);
      transition: transform 220ms ease;
    }

    details[open] .chevron {
      transform: rotate(225deg);
    }

    details.closing .chevron {
      transform: rotate(45deg);
    }

    .logic-body {
      padding: 0 12px 12px;
      font-size: 14px;
      line-height: 1.6;
      color: var(--text);
      word-break: break-word;
      overflow: hidden;
      transition: height 240ms ease, opacity 200ms ease;
      will-change: height, opacity;
    }

    .logic-body p {
      margin: 0 0 8px;
    }

    .logic-body p:last-child {
      margin-bottom: 0;
    }

    .numbered-item,
    .bullet-item {
      display: grid;
      gap: 6px;
      align-items: start;
    }

    .numbered-item {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .bullet-item {
      grid-template-columns: 10px minmax(0, 1fr);
      padding-left: 16px;
    }

    .item-marker {
      font-weight: 400;
      white-space: nowrap;
    }

    .bullet-dot {
      width: 5px;
      height: 5px;
      margin-top: 11px;
      border-radius: 50%;
      background: var(--text);
    }

    .item-copy {
      min-width: 0;
    }

    .logic-body ul {
      display: grid;
      gap: 8px;
      margin: 0 0 8px;
      padding-left: 18px;
    }

    .logic-body li {
      margin: 0;
    }

    .logic-body strong {
      color: var(--text);
      font-weight: 800;
    }

    .overview .text-link,
    .logic-body .text-link,
    .risk-list .text-link {
      color: var(--link);
      text-decoration: none;
      font-weight: inherit;
    }

    .key {
      font-weight: 800;
    }

    .risk-card {
      display: grid;
      gap: 12px;
      padding: 12px;
      background:
        linear-gradient(90deg, var(--risk-bg), var(--risk-bg)),
        linear-gradient(90deg, #fff3e0, #fff7ed),
        #ffffff;
    }

    .risk-head {
      width: 100%;
      border: 0;
      display: grid;
      grid-template-columns: 30px minmax(0, 1fr) 22px;
      gap: 12px;
      align-items: center;
      padding: 0;
      background: transparent;
      color: inherit;
      text-align: left;
      cursor: pointer;
      font: inherit;
      -webkit-tap-highlight-color: transparent;
    }

    .risk-head .icon {
      background: var(--risk-icon-bg);
      color: #ffb84c;
    }

    .risk-head h3 {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
    }

    .risk-card.open .risk-head .chevron {
      transform: rotate(225deg);
    }

    .risk-list {
      display: grid;
      gap: 8px;
      overflow: hidden;
      transition: height 240ms ease, opacity 200ms ease;
      will-change: height, opacity;
    }

    @media (prefers-reduced-motion: reduce) {
      .chevron,
      .logic-body,
      .risk-list {
        transition: none;
      }
    }

    .risk-item {
      margin: 0;
      color: var(--risk-text);
      font-size: 13px;
      line-height: 1.5;
      word-break: break-word;
    }

    .risk-divider {
      height: 1px;
      background: repeating-linear-gradient(90deg, var(--risk-line) 0 3px, transparent 3px 6px);
    }

    @media (max-width: 360px) {

      summary,
      .risk-head {
        grid-template-columns: 28px minmax(0, 1fr) 20px;
        gap: 10px;
      }

      .icon {
        width: 28px;
        height: 28px;
      }

      .stock-strip {
        grid-auto-columns: minmax(100px, 120px);
      }
    }

}
    
</style>
<style lang="scss" scope>

    @import "~@/assets/sass/global.scss";

    /* 未购买时*/
    .not_purchased{
        width: 100vw;
        min-height: 100vh;
        position: absolute;
        left: 0;
        top: 0;
        background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/znzg_bg.png) 0 0;
        background-size: 100%;
        transform-origin: center center;
        .not_purchased_box{
            text-align: center;
            width: rem(673px);
            min-height: rem(455px);
            background: rgba(255, 255, 255, 0.96);
            box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
            border-radius: rem(20px);
            position: absolute;
            bottom: rem(92px);
            left: 50%;
            transform: translateX(-50%);
            z-index: 20;
            .not_name{
                height: rem(42px);
                font-size: rem(30px);
                font-weight: 400;
                color: #000000;
                line-height: rem(48px);
                padding-top: rem(25px);
            }
            .not_situation{
                height: rem(30px); //42原是
                font-size: rem(26px);
                font-weight: 400;
                color: #FE484A;
                line-height: rem(30px);
            }
            .not_trait{
                display: flex;
                justify-content: space-around;
                margin: rem(24px) 0 rem(44px);
                align-items: flex-end;
                .not_trait_img{
                    margin-bottom: rem(22px);
                    .img_one{
                        width: rem(44px);
                    }
                    .img_two{
                        width: rem(55px);
                    }
                    .img_three{
                        width: rem(50px);
                    }
                }
            }
            .not_trait_word{
                height: rem(28px);
                font-size: rem(20px);
                font-weight: 400;
                color: #333333;
                line-height: rem(29px);
            }
            .not_btn{
                padding: 0 rem(47px);
                height: rem(92px);
                background: #FE484A;
                box-shadow: 0px rem(4px) rem(11px) 0px rgba(231, 69, 69, 0.5);
                border-radius: rem(53px);
                text-align: center;
                font-size: rem(30px);
                font-weight: 400;
                color: #FFFFFF;
                line-height: rem(92px);
                margin: 0 auto;
                display: inline-block;
            }
            >p{
                margin-top: rem(20px);
                height: rem(30px);
                font-size: rem(22px);
                font-weight: 400;
                color: #636363;
                line-height: rem(30px);
                text-align: center;
            }
            .agq{

                font-size: rem(26px);
                font-weight: 400;
                color: #636363;
                line-height: rem(37px);
                padding-bottom: rem(30px);
                >a{
                    padding-left: rem(35px);
                    color: #1D88D0;
                    background: url(../../assets/images/znzg/agq.png) 0 center no-repeat;
                    background-size: rem(28px);
                }
            }
        }
    }



    /*购买之后*/
    .data_update{
        padding-left: rem(28px);
        // width: 100vw;
        height: rem(53px);
        background: #FFF7F1;
        font-size: rem(24px);
        font-weight: 400;
        color: #F68532;
        line-height: rem(53px);
    }
    .data_box{
        border-top: rem(12px) solid #F5F6F7;
        padding: 0 rem(28px);
        background-color: #ffffff;
        .goodness{
            padding-bottom: rem(25px);
            .goodness_title{
                height: rem(42px);
                img{
                    width: rem(30px);
                    margin-right: rem(6px);
                    position: relative;
                    top: rem(6px);
                }
                span{
                    height: rem(42px);
                    font-size: rem(30px);
                    font-weight: 500;
                    color: #FE484A;
                    line-height: rem(42px);
                }
                .goodness_title_blue{
                    color: #3E89FE;
                }
            }
            .goodness_content{
                li{
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    line-height: rem(40px);
                    list-style: none;
                    margin-left: rem(36px);
                    position: relative;
                }
                .goodness_point{
                    width: rem(10px);
                    height: rem(10px);
                    background-color: #FE484A;
                    border-radius: 50%;
                    position: absolute;
                    left: rem(-26px);
                    top: rem(16px);
                }
                .goodness_content_blue{
                    background-color: #3E89FE;
                }
            }
        }


        .target_price{
            padding-bottom: rem(50px);
            .target_price_content{
                font-size: rem(28px);
                font-weight: 400;
                color: #636363;
                line-height: rem(40px);
                margin-bottom: rem(50px);
                .span_tag{
                    color: #FE484A;
                }

            }
            .target_price_content_none{
                margin-bottom: 0;
            }
            .target_price_chart{
                height: rem(300px);
                margin: rem(50px) rem(100px) rem(20px) rem(120px);
                position: relative;
                .target_price_chart_box{
                    width: 100%;
                    height: rem(2px);
                    position: absolute;
                    left: 0;
                    font-size: rem(22px);
                    > div:nth-child(1){
                        position: absolute;
                        left: rem(-120px);
                        //top: rem(-15px);
                        color: #939393;
                        z-index: 1;
                    }
                    > div:nth-child(2){
                        position: absolute;
                        right: rem(-100px);
                        //top: rem(-15px);
                        color: #333333;
                    }
                    > div.target_font_blue{
                        color: #3E89FE;
                    }
                    > div.target_font_red{
                        color: #FE484A;
                    }
                }
                .target_price_chart_box_red{
                    background: #FE484A;
                }
                .target_price_chart_box_blue{
                    background: #3E89FE;

                }

                .target_price_chart_squre{
                    position: absolute;
                    left: 0;
                    min-height: rem(32px);
                    background: #f6f9ff;
                    width: 100%;
                    .target_price_chart_squre_text{
                        font-size: rem(24px);
                        color: #f2666d;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        position: absolute;
                        left: 55%;
                    }
                    .target_price_chart_squre_tag{
                        position: absolute;
                        top: 0;
                        left: 50%;
                        height: 100%;
                        width: rem(2px);
                        background: #5e94fa;
                        > div:nth-child(1){
                            position: absolute;
                            width: rem(2px);
                            height: rem(24px);
                            top: 0;
                            left: rem(-4px);
                            -ms-transform: rotate(20deg);
                            transform: rotate(
                                            20deg
                            );
                            -webkit-transform: rotate(
                                            20deg
                            );
                            background: #5e94fa;
                        }
                        > div:nth-child(2){
                            position: absolute;
                            width: rem(2px);
                            height: rem(24px);
                            top: 0;
                            left: rem(4px);
                            -ms-transform: rotate(-20deg);
                            transform: rotate(
                                            -20deg
                            );
                            -webkit-transform: rotate(
                                            -20deg
                            );
                            background: #5e94fa;
                        }
                    }
                }
            }
            .target_price_content_chart{
                margin-bottom: rem(44px);
                .target_price_content_chart_pos_box{
                    transform: translate(-50%, 0);
                    left: 50%;
                    position: relative;
                }
                .target_price_content_chart_pos{
                    width: rem(32px);
                    height: rem(43px);
                    background: url("https://cdncos.aigupiao.com/assets/wap/img/znzg/pos.png");
                    background-size: 100%;
                    margin-bottom: rem(13px);
                    position: relative;
                    left: 80%;
                }
                .target_price_content_chart_wrap{
                    display: flex;
                    .target_price_content_chart_box{
                        width: 19.6%;
                        margin-right: rem(6px);
                        .target_price_content_chart_box_color{
                            height: rem(23px);
                            background: linear-gradient(90deg, #86E259 0%, #BFF27B 100%);
                            border-radius: rem(4px);
                        }
                        .color2{
                            background: linear-gradient(90deg, #B3ED58 0%, #DEE800 100%);
                        }
                        .color3{
                            background: linear-gradient(90deg, #FFD968 0%, #FFB04D 100%);
                        }
                        .color4{
                            background: linear-gradient(90deg, #FF9354 0%, #F87F58 100%);
                        }
                        .color5{
                            background: linear-gradient(90deg, #F66A3E 0%, #EA1B00 100%);
                        }
                        .target_price_content_chart_box_word{
                            height: rem(74px);
                            font-size: rem(22px);
                            font-weight: 400;
                            color: #939393;
                            line-height: rem(74px);
                            text-align: center;
                        }
                    }
                }
            }



            .grade_table{
                .grade_table_title{
                    width: 100%;
                    background: #F5F6F7;
                    height: rem(72px);
                    span{
                        width: 33.3%;
                        display: inline-block;
                        text-align: center;
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(72px);
                    }
                }

                ul{
                    li{
                        height: rem(85px);
                        border-bottom: 1px solid #EBEBEB;
                        span{
                            width: 33.3%;
                            display: inline-block;
                            text-align: center;
                            font-size: rem(26px);
                            font-weight: 400;
                            color: #636363;
                            line-height: rem(85px);
                        }
                        .grade_red{
                            color: #FE484A;
                        }
                        .grade_green{
                            color: #0AC890;
                        }
                        .grade_yellow{
                            color: #F68532;
                        }
                    }
                }
            }

            .technical_analysis{
                .technical_analysis_title{
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #333333;
                    line-height: rem(40px);
                    margin-bottom: rem(20px);
                    img{
                        width: rem(10px);
                        margin-right: rem(6px);
                    }
                }
                .technical_analysis_box{
                    span{
                        padding: rem(9px) rem(16px);
                        background: #FEF4F4;
                        border-radius: 4px;
                        font-size: 26px;
                        font-weight: 400;
                        color: #FE484A;
                        line-height: rem(55px);
                        display: inline-block;
                        margin: rem(10px);
                    }
                    .down_span{
                        background: #E3F6F2;
                        color: #09BF99;
                    }
                    .hold_span{
                        background: #FFEEE1;
                        color: #DB8E5B
                    }
                }
            }

            .longhu{
                margin-bottom: rem(30px);
            }
            .longhu_box{

                .longhu_range{
                    display: flex;
                    height: rem(80px);
                    border-bottom: rem(1px) solid #EBEBEB;
                    border-top: rem(1px) solid #EBEBEB;
                    line-height: rem(80px);
                    justify-content: space-between;
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    align-items: center;
                    margin-bottom: rem(17px);
                    img{
                        width: rem(26px);
                        margin-right: rem(10px);
                    }
                    .longhu_rise_red{
                        margin-left: rem(15px);
                        color: #FE484A;
                    }
                    .longhu_rise_green{
                        margin-left: rem(15px);
                        color: #0AC890;
                    }
                }


                .longhu_total{
                    display: flex;
                    margin-bottom: rem(30px);
                    > div{
                        width: 33.3%;
                        text-align: center;
                        font-size: rem(28px);
                        font-weight: 400;
                        color: #636363;

                        >p{
                            line-height: rem(60px);
                        }
                        .total_num{
                            font-size: rem(34px);
                            font-weight: 400;
                            color: #FE484A;
                            line-height: rem(48px);
                        }
                        .total_num_sell{
                            color: #448DFE;
                        }
                        .total_num_net{
                            color: #333333;
                        }
                    }
                }

                .longhu_reason{
                    padding: rem(16px);
                    background: #FFF7F1;
                    border-radius: 4px;
                    font-size: rem(26px);
                    font-weight: 400;
                    color: #F68532;
                    line-height: rem(37px);
                    margin-bottom: rem(40px);
                }
                .expand{
                    width: rem(85px);
                    margin: rem(35px) auto 0;
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #939393;
                    line-height: rem(33px);
                    img{
                        width: rem(26px);
                        margin-right: rem(9px);
                    }
                }
                .longhu_table{
                    .longhu_table_title{
                        padding: 0 rem(16px);
                        display: flex;
                        height: rem(72px);
                        background: #F5F6F7;
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(72px);
                        div{
                            flex: 1;
                        }
                        .longhu_table_buy5{
                            flex: unset;
                            margin-right: rem(40px);
                        }
                    }
                    .longhu_table_sell{
                        text-align: right;
                    }
                    .longhu_table_buy5{
                        width: rem(344px);
                    }
                    ul{
                        padding: 0 rem(16px);
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #636363;
                        line-height: rem(37px);
                        li{
                            display: flex;
                            height: rem(114px);
                            align-items: center;
                            border-bottom: rem(1px) solid #EBEBEB;
                            div{
                                flex: 1;
                            }
                            .longhu_table_buy5{
                                flex: unset;
                                margin-right: rem(40px);
                            }
                        }
                    }
                    .longhu_green{
                        color: #09BF99;
                    }
                    .longhu_red{
                        color: #FE484A;
                    }
                    .longhu_blue{
                        color: #448DFE;
                    }
                }


            }

        }

        .target_price_p{
            color:#333333;
            margin-bottom: 10px;
            
            >h1{
                font-weight: 500;
                font-size: 15px;
                line-height: 100%;

                >span{
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 100%;
                    margin-left: 5px;
                    color:#939393;
                }
            }

            .plate_wrap{
                display: flex;
                flex-wrap: wrap;
                margin-top: 5px;

                
                .plate_i{
                    display: flex;
                    flex-direction: column;
                    margin-top: 6px;
                    align-items: center;
                    justify-content: center;
                    background: #F2F3F5;
                    margin-right: 6px;
                    width: 106px;
                    height: 70px;
                    border-radius: 4px;
                    position: relative;
                    box-sizing: border-box;

                    >i{
                        min-width: 36px;
                        height: 15px;
                        top: -5px;
                        right: -3px;
                        position: absolute;
                        padding-right: 5px;
                        padding-left: 5px;
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                        border-bottom-right-radius: 4px;
                        box-sizing: border-box;
                        background: #FF443D;
                        font-weight: 400;
                        font-size: 10px;
                        line-height: 100%;
                        text-align: center;
                        color: #fff;
                        font-style: normal;
                        z-index: 1;
                        display: flex;
                        align-items: center;
                        white-space: nowrap;

                    }
                    >h1{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 100%;
                    }
                    >span{
                        font-weight: 500;
                        font-size: 15px;
                        line-height: 100%;
                        margin-left: 5px;
                        font-family: DINPro;
                        color: #7F8E9D;
                        margin-top: 5px;
                    }

                    &.red{
                        background: #FFF3F3;
                        >span{
                            color: #CB382D;
                        }
                    }

                    &.green{
                        background: #EFFAF3;
                        >span{
                            color: #659957;
                        }
                    }
                }

                .plate_i:nth-child(3n){
                    margin-right: 0;
                }
            }
        }

        .target_price_p2{
            color:#333333;
            background: #FAF9FE;
            border-radius: 4px;
            padding: 5px;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 20px;

            p{
                margin: 0 0 5px;
            }

            .red{
                background: #FF443D;
                padding: 1px 4px;
                color: #fff;
                margin-right: 5px;
                border-radius: 4px;
            }
        }



    }
    .company_box{
        background-color: #ffffff;
        overflow: auto;
        .grade_box{
            width: rem(694px);
            height: rem(257px);
            background: #FFFFFF;
            border-radius: rem(24px);
            margin: rem(35px) auto rem(50px);
            box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
            display: flex;
            .company_chart{
                width: 56%;
            }
            .grade{
                width: 44%;
                border-left: rem(1px) solid #F1F1F1;
                text-align: center;
                .grade_name{
                    height: rem(40px);
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    line-height: rem(40px);
                    margin-top: rem(38px);
                }
                .grade_number{
                    height: rem(101px);
                    font-size: rem(68px);
                    font-weight: 600;
                    color: #FE484A;
                    line-height: rem(101px);
                }
                .grade_word{
                    height: rem(42px);
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #939393;
                    line-height: rem(33px);
                    span{
                        font-size: rem(30px);
                        color: #F68532;
                    }
                }
            }
        }
        .company_quality{
            margin-top: rem(50px);
            margin-bottom: rem(30px);
            padding: 0 rem(24px);
            .company_quality_title{
                height: rem(45px);
                margin-bottom: rem(20px);
                display: flex;
                align-items: center;
                img{
                    width: rem(33px);
                    margin-right: rem(9px);
                }
            }
            .company_quality_content{
                ul{
                    margin-left: rem(12px);
                    border-left:  rem(2px) dashed #979797;
                    padding-left: rem(28px);
                    li{
                        font-size: rem(30px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(42px);
                        margin-bottom: rem(20px);
                        position: relative;
                        .point{
                            width: rem(18px);
                            height: rem(18px);
                            background: #FFFFFF;
                            border-radius: 50%;
                            border: rem(3px) solid #FF3939;
                            position: absolute;
                            left: rem(-41px);
                            transform: translate(0,-50%);
                            top: 50%;
                        }
                        .point_tag{
                            color: #FE484A;
                            font-size: rem(34px);
                        }
                        .blue{
                            border: rem(3px) solid #619EFF;
                        }
                    }
                }
                .company_tag{
                    margin-left: rem(42px);
                    padding: 0 rem(15px);
                    height: rem(40px);
                    background: #FF3939;
                    border-radius: rem(4px);
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: rem(40px);
                    text-align: center;
                    display: inline-block;
                }
                .tag_blue{
                    background: #63A0FF;
                }
            }
        }
    }

    .risk_statement{
        width: 100%;
        height: rem(100px);
        background: #F5F6F7;
        font-size: rem(24px);
        font-weight: 400;
        color: #636363;
        line-height: rem(100px);
        text-align: center;
    }


    /* 通用样式  */
    .big_title_common{
        font-size: rem(32px);
        font-weight: 600;
        color: #333333;
        line-height: rem(45px);
    }
    .big_title_margin{
        display: inline-block;
        margin: rem(30px) 0 rem(20px);
    }

    /*  图表 */
    #company_chart{
        width: rem(390px);
        height: rem(256px);
    }

    #ratio_chart{
        width: rem(700px);
        height: rem(430px);
    }
    #financing_chart{
        width: rem(700px);
        height: rem(430px);
    }
    #k_chart{
        width: rem(700px);
        height: rem(250px);
    }

    #k_chart2,#time_chart{
        width: rem(650px);
        height: rem(300px);
    }

    #k_chart3,#volume_chart {
        width: rem(650px);
        height: rem(80px);
    }



/*    html{
        touch-action: none;
    }*/
    .none{
        min-height: 100vh;
        background: #fff;
        padding-top: 0.5px;
        .none_img{
            width: rem(590px);
            height: rem(448px);
            margin: rem(148px) auto rem(99px);
            img{
                width: 100%;
                height: 100%;
            }

        }
        p{
            height: rem(42px);
            font-size: rem(30px);
            color: #636363;
            line-height: rem(42px);
            text-align: center;
        }
    }

    .target_price_p2 font{
        display: inline-flex;
    }
</style>
